import { contentFor } from '../transport/content'
import type { Locale } from '../transport/types'

export function Footer({ locale }: { locale: Locale }) {
  const content = contentFor(locale)
  return (
    <footer className="site-footer map-footer">
      <div className="map-footer__inner">
        <strong>{content.brand}</strong>
        <span>{content.brandSubtitle}</span>
        <small>© {new Date().getFullYear()}</small>
      </div>
    </footer>
  )
}
